export default __webpack_public_path__ + "static/media/icon-reglage-haut_droite.4d7b05f8.svg";